import { Element } from "@xmpp/xml"
import { RoadDistance } from "@/components/timeline/planner/plannerPointRanking"

const COMMAND_NS = "http://jabber.org/protocol/commands"
const JSON_NS = "urn:xmpp:json:0"

const ApproachDistancesParser = {
  // Dojazd drogowy jest doprecyzowaniem rankingu, nie jego warunkiem — każda
  // odpowiedź, której nie umiemy odczytać, daje pustą mapę i planer zostaje na
  // odległości w linii prostej.
  parse(stanza: Element): Map<string, RoadDistance> {
    const result = new Map<string, RoadDistance>()
    const jsonElement = stanza
      .getChild("command", COMMAND_NS)
      ?.getChild("json", JSON_NS)
    if (!jsonElement) return result

    let parsed: unknown
    try {
      parsed = JSON.parse(jsonElement.text())
    } catch {
      return result
    }

    const distances = (parsed as { distances?: unknown })?.distances
    if (!Array.isArray(distances)) return result

    for (const entry of distances) {
      if (typeof entry !== "object" || entry === null) continue
      const { chatJid, km, durationMinutes } = entry as Record<string, unknown>
      if (typeof chatJid !== "string" || !chatJid) continue
      if (typeof km !== "number" || !Number.isFinite(km)) continue
      result.set(chatJid, {
        km,
        durationMinutes:
          typeof durationMinutes === "number" &&
          Number.isFinite(durationMinutes)
            ? durationMinutes
            : undefined,
      })
    }
    return result
  },
}

export default ApproachDistancesParser
